import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Colleague_Interface } from 'src/app/Interface/Colleague_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ColleagueService {

  constructor(private http: HttpClient) { }

  GetRecord(startDate: String, endDate: String, customer: String, code: String, SubmitPeriodDate: String): Observable<Array<Colleague_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Colleague?startDate=" + startDate
      + "&endDate=" + endDate
      + "&customer=" + customer
      + "&code=" + code
      + "&SubmitPeriodDate=" + SubmitPeriodDate
    ).pipe(
      map(data => {
        return data as Array<Colleague_Interface>
      })
    )
  }

}
